export default __webpack_public_path__ + "static/media/FUERZA_LABORAL_ROUTE_IMG.ccd70c78.jpg";